module.exports = __webpack_public_path__ + "static/media/19.cb71c5df.png";